<!-- <button mat-stroked-button [disabled]="disabled()" (click)="signInWithFacebook()">
  <div class="button-label">
    <r2e-facebook-icon class="icon" />
    Facebook
  </div>
</button> -->

<button mat-stroked-button [disabled]="disabled()" (click)="signInWithGoogle()">
  <div class="button-label">
    <r2e-google-icon class="icon" />
    Google
  </div>
</button>
